import { IStationInfoBase, TStationComposedId } from "../../dto";
import { areStationRowsEqual } from "../routing-waypoint/routing-waypoint-station-row.helpers";

const STATION_COMPOSED_ID_PATTERN = /^(-?\d+)-(-?\d+)$/;

export const getStationComposedId = (
  station: IStationInfoBase,
): TStationComposedId => {
  if (!station.secondaryId) {
    return `${station.id}-${0}`;
  }

  return `${station.id}-${station.secondaryId}`;
};

export const areStationsEqual = ({
  a,
  b,
}: {
  a: IStationInfoBase;
  b: IStationInfoBase;
}): boolean => areStationRowsEqual({ a, b });

const parseStationComposedId = (
  composedId: TStationComposedId,
): { id: number; secondaryId: number } => {
  const matched = composedId.match(STATION_COMPOSED_ID_PATTERN);

  if (!matched) {
    return { id: Number(composedId), secondaryId: 0 };
  }

  return { id: Number(matched[1]), secondaryId: Number(matched[2]) };
};

export const extractStationId = (composedId: TStationComposedId): number =>
  parseStationComposedId(composedId).id;

export const extractStationSecondaryId = (
  composedId: TStationComposedId,
): number => parseStationComposedId(composedId).secondaryId;

export const stationComposedIdMatch = ({
  station,
  composedId,
}: {
  station: IStationInfoBase;
  composedId: TStationComposedId;
}): boolean => {
  const { id, secondaryId } = parseStationComposedId(composedId);

  return areStationRowsEqual({
    a: station,
    b: { id, secondaryId },
  });
};
